/**
 * Exclusive accordion behavior for .js-product-accordion-item elements
 * (product accordions, FAQ accordions). Extracted from the legacy webpack
 * bundle (assets/scripts.js) so bundle-free pages — the MediSpa landing
 * pages — can use it standalone.
 *
 * All items on the page form one exclusive group: opening an item closes
 * the others; clicking an open item closes it. Each item exposes its
 * content height as the --content-height CSS variable, which the accordion
 * CSS uses for the expand/collapse transition.
 */
function initProductAccordions(): void {
  const items = Array.from(document.querySelectorAll<HTMLElement>('.js-product-accordion-item'));
  if (items.length === 0) return;

  const setContentHeight = (item: HTMLElement): void => {
    const content = item.querySelector<HTMLElement>('.js-product-accordion-content');
    if (content) {
      item.style.setProperty('--content-height', `${content.scrollHeight}px`);
    }
  };

  items.forEach((item) => {
    const trigger = item.querySelector<HTMLElement>('.js-accordion-trigger');

    if (trigger) {
      trigger.addEventListener('click', () => {
        if (item.classList.contains('is-active')) {
          item.classList.remove('is-active');
          return;
        }

        items.forEach((other) => other.classList.remove('is-active'));
        item.classList.add('is-active');
      });
    }

    setContentHeight(item);
  });

  // The legacy bundle measured once at init; recompute on resize so
  // reflowed rich-text answers don't get clipped.
  window.addEventListener('resize', () => {
    items.forEach(setContentHeight);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductAccordions);
} else {
  initProductAccordions();
}
